module.exports = __webpack_public_path__ + "img/bznscard-qr-code.73da47cc.jpg";